import { render } from "./webRefereePage.vue?vue&type=template&id=c6f2201a&ts=true"
import script from "./webRefereePage.vue?vue&type=script&lang=ts"
export * from "./webRefereePage.vue?vue&type=script&lang=ts"

import "./webRefereePage.vue?vue&type=style&index=0&id=c6f2201a&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__